"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapPositionUtils = require("../util/mapPositionUtils");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/BoundaryManager/Parcel.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Checks to see if the passed holes value is just a single array, or if it is an array of arrays
 * @param holes
 * @returns boolean
 */
var isHolesArrayOfArrays = function isHolesArrayOfArrays(holes) {
  return holes.length > 0 && Array.isArray(holes[0]);
};

var Parcel =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Parcel, _PureComponent);

  function Parcel() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Parcel.prototype;

  _proto.convertPolygonsToPathLine = function convertPolygonsToPathLine() {
    // We need to convert all of the polygon arrays to a SVG path string
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
    return this.props.polygons.reduce(function (lineAcc, _ref) {
      var shell = _ref.shell,
          holes = _ref.holes;
      var shellPathLine = (0, _mapPositionUtils.getPathLineFromCoordinateArray)(shell); // In some polygons the 'holes' property is an array of coordinate arrays. In that case
      // we need to loop through the 'holes' array and convert each coordinate array
      // into a path string.

      var holesPathLine = isHolesArrayOfArrays(holes) ? holes.reduce(function (acc, hole) {
        return acc + (0, _mapPositionUtils.getPathLineFromCoordinateArray)(hole);
      }, '') : (0, _mapPositionUtils.getPathLineFromCoordinateArray)(holes);
      return lineAcc.concat(shellPathLine, holesPathLine);
    }, '');
  };

  _proto.renderDebugInfo = function renderDebugInfo() {
    if (this.props.debug) {
      return _react.default.createElement("p", {
        style: {
          color: 'black'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        },
        __self: this
      }, this.props.row, ", ", this.props.column);
    }

    return null;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        polygons = _this$props.polygons,
        fullSize = _this$props.fullSize,
        row = _this$props.row,
        column = _this$props.column,
        strokeType = _this$props.strokeType,
        isMouseOver = _this$props.isMouseOver,
        id = _this$props.id,
        isState = _this$props.isState;

    if (polygons.length === 0) {
      return null;
    }

    var inlineStyle = {};

    if (fullSize) {
      inlineStyle.overflow = 'visible';
    }

    var isStateClass = isState ? ' state' : '';
    var isHoveredClass = isMouseOver ? ' isHovered' : '';
    var pathClassName = "" + strokeType + isStateClass + isHoveredClass;
    return _react.default.createElement("div", {
      id: "parcel-" + id,
      style: _objectSpread({}, this.props.style, inlineStyle),
      className: fullSize ? 'full-boundary-container' : 'boundary-container',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63
      },
      __self: this
    }, _react.default.createElement("svg", {
      style: inlineStyle,
      className: fullSize ? 'full-boundary-svg' : 'boundary-svg',
      "data-row": row,
      "data-column": column,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68
      },
      __self: this
    }, _react.default.createElement("path", {
      className: pathClassName,
      d: this.convertPolygonsToPathLine(),
      strokeWidth: "2",
      fill: "none",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74
      },
      __self: this
    })), this.renderDebugInfo());
  };

  return Parcel;
}(_react.PureComponent);

Parcel.propTypes = process.env.NODE_ENV !== "production" ? {
  style: _propTypes.default.object,
  id: _propTypes.default.string,
  row: _propTypes.default.number,
  column: _propTypes.default.number,
  polygons: _propTypes.default.array,
  fullSize: _propTypes.default.bool,
  strokeType: _propTypes.default.string,
  // zoom is pulled off each child in MapContentPositioner
  // so it's not actually unused
  // eslint-disable-next-line react/no-unused-prop-types
  zoom: _propTypes.default.number,
  debug: _propTypes.default.bool,
  isMouseOver: _propTypes.default.bool,
  isState: _propTypes.default.bool
} : {};
Parcel.defaultProps = {
  style: {},
  id: null,
  row: 0,
  column: 0,
  polygons: [],
  fullSize: false,
  strokeType: '',
  zoom: 4,
  debug: false,
  isMouseOver: false,
  isState: false
};
var _default = Parcel;
exports.default = _default;